import React from "react";
import Header from "gatsby-theme-carbon/src/components/Header";

const ShadowedCustomHeader = (props) => {
	return (
		<div>
			<Header {...props}>jasontmiani.com</Header>
		</div>
	);
};

export default ShadowedCustomHeader;
